import { createSlice } from "@reduxjs/toolkit";
import { updateFactCheckStatus } from "./ApprovalsApi";

const updateFactCheckStatusSlice = createSlice({
    name: "updateFactCheckStatus",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(updateFactCheckStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateFactCheckStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(updateFactCheckStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default updateFactCheckStatusSlice.reducer;
